import styled from "styled-components";
import { Wrapper } from "../../common";
import { Box, Typography } from "@material-ui/core";

export const WrapperBox = styled(Wrapper)`
    display: block;
    width: 100%;
    max-height: calc(100vh - 75px);
    height: 100%;
    background-color: white;
    padding: 0;
    overflow: hidden;
`;

export const WrapperWithout = styled(Wrapper)`
    display: block;
    width: 100%;
    background-color: white;
    padding: 0;
    overflow: hidden;
`;

export const OrderInfo = styled.div`
    display: flex;
    align-items: center;
    padding: 0px 28px;
    & > svg {
        fill: ${props => props.theme.colors.primary};
        font-size: 40px;
    }
    span {
        font-size: 16px;
        margin-left: 16px;
        font-weight: 300;
        b {
            font-weight: bold;
        }
    }
`

export const OrderFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
    padding: 0 28px 28px;
`

export const Body = styled.div`
    padding: 0 24px 24px;
    height: calc(100% - 83px);
    width: 100%;
    overflow: auto;
`

export const ErrorBody = styled.div`
    padding: 24px 24px 70px;
    width: 100%;
    overflow: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`

export const ModalWrapper = styled(Box)`
    padding: 16px 30px;
`
export const ModalTitle = styled(Typography)`
    font-size: 18px !important;
    font-weight: 500 !important;
    color: ${props => props.theme.colors.primary}
`

export const ModalBody = styled(Box)`
    margin: 8px 0;
`

export const ModalFooter = styled(Box)`
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
`